/**
 * Environment variables utility
 * This module provides a simple way to access environment variables
 * that are passed from the app (source of truth) to packages.
 *
 * Usage:
 *   import { getEnv, getEnvVar } from '../utils/env';
 *
 *   const env = getEnv();
 *   const apiUrl = getEnvVar('REACT_APP_API_BASE_URL_PREFIX');
 */

let envRegistry = null;

/**
 * Initialize the environment variables registry
 * This should be called once from the root component with env prop
 * @param {Object} env - Environment variables object from app
 */
export const initializeEnv = (env = {}) => {
  envRegistry = env;
};

/**
 * Get all environment variables
 * @returns {Object} Environment variables object
 * @throws {Error} If env has not been initialized
 */
export const getEnv = () => {
  // if (envRegistry === null) {
  //   throw new Error(
  //     'Environment not initialized. Make sure to call initializeEnv() in the root component with the env prop.'
  //   );
  // }
  return envRegistry;
};

/**
 * Get a specific environment variable
 * @param {string} key - Environment variable key
 * @param {*} defaultValue - Default value if key is not found
 * @returns {*} Environment variable value or defaultValue
 */
export const getEnvVar = (key, defaultValue = undefined) => {
  const env = getEnv();
  return env?.[key] ?? defaultValue;
};
